"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitizeOptions = exports.CONTENT_ALL_PAGES = void 0;
// We are restricting the allowed tags and attributes
const sanitizeOptions = exports.sanitizeOptions = {
  allowedTags: ['a', 'b', 'br', 'div', 'em', 'i', 'img', 'p', 's', 'span', 'strong', 'sub', 'sup'],
  disallowedTagsMode: 'discard',
  allowedAttributes: {
    a: ['href', 'name', 'target', 'rel'],
    img: ['src', 'srcset', 'alt', 'title', 'width', 'height'],
    // eslint-disable-next-line @typescript-eslint/naming-convention -- data-* and aria-* are allowed
    '*': ['class', 'style', 'data-*', 'aria-*']
  },
  selfClosing: ['img', 'br'],
  allowedSchemes: ['http', 'https'],
  allowedSchemesByTag: {
    img: ['data', 'http', 'https']
  },
  allowedSchemesAppliedToAttributes: ['href', 'src'],
  allowProtocolRelative: true,
  enforceHtmlBoundary: false
};
const CONTENT_ALL_PAGES = exports.CONTENT_ALL_PAGES = 'content-all-pages';
